var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaginationChevronsRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.6 1.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.30149 6.4L0.250746 1.44176C0.0835821 1.27766 0 1.07839 0 0.843956C0 0.609524 0.0835821 0.410256 0.250746 0.246154C0.41791 0.0820513 0.620895 0 0.859701 0C1.09851 0 1.30149 0.0820513 1.46866 0.246154L6.82388 5.5033C6.95522 5.63223 7.05075 5.77289 7.11045 5.92527C7.17015 6.07766 7.2 6.2359 7.2 6.4C7.2 6.5641 7.17015 6.72234 7.11045 6.87473C7.05075 7.02711 6.95522 7.16777 6.82388 7.2967L1.46866 12.5538C1.30149 12.7179 1.09851 12.8 0.859701 12.8C0.620895 12.8 0.41791 12.7179 0.250746 12.5538C0.0835821 12.3897 0 12.1905 0 11.956C0 11.7216 0.0835821 11.5223 0.250746 11.3582L5.30149 6.4Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9015 6.4L5.85075 1.44176C5.68358 1.27766 5.6 1.07839 5.6 0.843956C5.6 0.609524 5.68358 0.410256 5.85075 0.246154C6.01791 0.0820513 6.2209 0 6.4597 0C6.69851 0 6.90149 0.0820513 7.06866 0.246154L12.4239 5.5033C12.5552 5.63223 12.6507 5.77289 12.7104 5.92527C12.7701 6.07766 12.8 6.2359 12.8 6.4C12.8 6.5641 12.7701 6.72234 12.7104 6.87473C12.6507 7.02711 12.5552 7.16777 12.4239 7.2967L7.06866 12.5538C6.90149 12.7179 6.69851 12.8 6.4597 12.8C6.2209 12.8 6.01791 12.7179 5.85075 12.5538C5.68358 12.3897 5.6 12.1905 5.6 11.956C5.6 11.7216 5.68358 11.5223 5.85075 11.3582L10.9015 6.4Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginationChevronsRight);
export default __webpack_public_path__ + "static/media/Pagination_chevrons_right.5385b0d8f1c37b6307724f82affe7544.svg";
export { ForwardRef as ReactComponent };